export const experienceData = [
    {
        title: 'Software Engineering Intern',
        img: '/assets/images/experience/thd-logo.jpeg',
        //link: '#',
        details: {
            origin: 'The Home Depot',
            date: 'Summer 2025',
            tools: 'React, Python, FastAPI, OAuth, Glean, GCP, Google Cloud Store, BigQuery',
            description: 'Triage-assistance tool for SREs'
        },
        slug: 'thd-2025',
        desc: {
            p1: 'In Summer 2025, I worked with the Cart + Checkout Reliability Engineering Group to create a full-stack triage assistance tool.'
        } ,
        list1: {
            li1: 'Developed full-stack triage assistance tool for SREs to reduce incident resolution time and revenue impact during outages using React, Python, FastAPI, OAuth, Glean, Google Cloud Store, and BigQuery',
            li2: 'Built modules for system health monitoring, deployment validation, audit log analysis, dataset schema fetching, centralized resource display, URL / API endpoint mapping, Glean AI chatbot, and dynamic SQL query generation',
            li3: 'Automated 40% of triage flow, reducing manual toil time, GCP costs, and improving accessibility for new SREs',
        }
    },
    
    {
        title: 'Machine Learning Intern',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Hi-Rez Studios',
            date: 'Summer 2024 - Spring 2025',
            tools: 'Python/PyTorch, Unreal Engine, InvokeAI, Stable Diffusion',
            description: 'Generative AI tools / diffusion models for artists'
        },
        slug: 'hi-rez-2024',
        desc: {
            p1: 'From June 2024 to January 2025, I had the opportunity to work with a team of UI, concept, and FX artists \
            at Hi-Rez Studios to explore use cases of generative AI tools across all stages of game art preceeding the launch of Smite 2. \
            We focused on what was possible using open-source models and InvokeAI, an artist-first tool that enables the use of sketches and other work to guide the image generation process.\
            Proof of concept testing showed that using these resources and other tools that I created, asset creation time could be reduced by up to 75% and turn day-long projects into <3-hour tasks. ',
            plist: 'Here is a list of some of the specific things I worked on:',
        } ,
        list1: {
            li1: 'Unreal Engine blueprint for automatically creating image datasets of in-game characters for use in custom model training',
            li2: 'Automatic dataset captioner using Salesforce\'s BLIP model and JSONL file training paramaters generator',
            li3: 'Image segmentation tool capable of separating AI-generated image into a PSD file with artist-friendly layers using the PSDTools library and K-Means clustering for further touchups in Photoshop',
            li4: 'Node-based workflows inside Invoke for streamlining specific use cases (ex. Sketch to Painterly, Graybox to In-Game Screenshot)',
            li5: 'Pipelines for remastering Smite 1 ability icons into the Smite 2 art style',
            li6: '20+ Stable Diffusion LoRA image models for 3D characters, particle FX, UI icons, concept art, and personal art styles',
        }
    },

    {
        title: 'Product Management Intern',
        img: '/assets/images/experience/thd-logo.jpeg',
        //link: '#',
        details: {
            origin: 'The Home Depot',
            date: 'Summer 2024',
            tools: 'Figma, Photoshop, MS Office Suite',
            description: 'UX research on Home Services IVR systems + reworked UI designs'
        },
        slug: 'thd-2024',
        desc: {
            p1: 'In Summer 2024, I worked with the CX Reimagine Customer Services Workstream to analyze the customer\'s IVR entry experience. \
            My project focused on researching the existing online and in-store entry points for the Home Services program and offering \
            potential solutions for streamlining the IVR process.',
        } ,
        list1: {
            li1: 'Analyzed online/in-store entry points for Services program to identify friction points in customer journey and IVR',
            li2: 'Created actionable product strategy and hi-fi mockups in Figma that lead to reduction of 2000+ telephone entry points by 85% within 6 months',
        }
    },

    {
        title: 'Undergraduate Researcher',
        img: '/assets/images/experience/gt-expressive.jpg',
        link: 'https://expressivemachinery.gatech.edu/projects/luminai/',
        details: {
            origin: 'Expressive Machinery Lab',
            date: 'Spring 2024',
            tools: 'C#, NoSQL, MongoDB, Unity, Blender',
            description: 'Database tools and interaction design for embodied ML agent'
        },
        slug: 'eml-2024',
        desc: {
            p1: 'In Spring 2024, I worked for Georgia Tech\'s Expressive Machinery Lab under Dr. Brian Magerko. \
            I was lucky to be a part of the LuminAI team as they prepared for the world\'s first AI-Human improv dance performance, the culmination of 10+ years of prior research where human actions drive live generated responses from an embodied AI agent. \
            My tasks primarily focused on creating Unity and MongoDB-based tools for the researchers to aid in data collection, visualization, and performance management.',
            plist: 'Here is a list of some of the specific things I worked on:',
        } ,
        list1: {
            li1: 'Developed gesture database viewer for 3D visualization of movements and simpler database file management / cleanup ',
            li2: 'Created CSV-based interaction logging system with Azure Kinect SDK for use in KSU dance class for data collection',
            li3: 'Various bug fixes for avatar\'s inverse kinematic bone system and animation playback',
            li4: 'Designed algorithms to apply Viewpoints movement theories to AI avatar\'s gestures',
            li5: 'Wrote scripts to parse live audience responses to questionnaire and playback inside Unity scene',
            li6: 'Implemented UI designs and functionalities for avatar setting management during live performance'
        },
        links: {
            //Description, link, type, image
            lk1: ['Full Performance (Edited)','https://youtu.be/39KtahFtd3s?si=3arvfdaqyrA_gP42', 'yt', ''],
            lk2: ['Full Performance (Unedited)','https://youtu.be/2769H-81EmI', 'yt', ''],
            lk3: ['LuminAI Project Site','https://expressivemachinery.gatech.edu/luminai/', 'a', '/assets/images/projects/luminai-poster.png' ],
        }
    },

    {
        title: 'Undergraduate Researcher',
        img: '/assets/images/experience/gt-vip.jpeg',
        //link: 'https://expressivemachinery.gatech.edu/projects/luminai/',
        details: {
            origin: 'GT VIP - Unlocking and Analyzing Historical Texts',
            date: 'Spring 2024 - Spring 2025',
            tools: 'Python, PyTorch, SciKit Learn',
            description: 'NLP tools and analysis for Early Modern texts'
        },
        slug: 'vip',
        desc: {
            p1: 'Georgia Tech\'s Vertically Integrated Projects program allows students to work with faculty on long-term multidisciplinary research projects. \
            I was a part of the Unlocking and Analyzing Historical Texts VIP for 3 semesters from Spring 2024 to Spring 2025.\
            Our projects focused on applying Natual Language Processing tools and techniques to Ancient Greek and Early Modern English works using GT\'s High Perfomance Computing clusters. \
            My subteam focused on analyzing the variation in orthography over time in Early Modern English texts using the EEBO digital library, \
            denoting periods of major spelling change and the evolution of standardization of the English language in printing presses.',
            plist: 'Here is a list of some of the tasks we worked on:',
        } ,
        list1: {
            li1: 'Naive Bayes Classifier to predict decade based on TF-IDF tokens of document ',
            li3: 'Word cloud visualization for most informative features (words) for each decade',
            li4: 'Custom Levenstein Distance-based clustering of words and their variant spellings',
            li5: 'Statistical tests for evaluating best cluster distance threshold',
            li6: 'Visualizations for Spelling Variation Entropy per Decade per-cluster and for all word clusters',
            li7: 'Hypotheses for correlated events that would cause periods of spelling normalization'
        },
    },

    {
        title: 'VR Software Developer',
        img: '/assets/images/experience/gt-oit-omniverse.jpeg',
        //link: 'https://expressivemachinery.gatech.edu/projects/luminai/',
        details: {
            origin: 'GT OIT - Academic/Research Technology Division',
            date: 'Spring 2023 - Spring 2024',
            tools: 'C#, Unity, NVIDIA Omniverse, LumaAI, Blender, Figma',
            description: 'Prototypes for emerging 3D / VR / AI technologies'
        },
        slug: 'oit',
        desc: {
            p1: 'From Spring 2023 to Spring 2024 I worked under Didier Contis in Academic/Research Technology Division of Georgia Tech\'s Office of Information Technology. \
            My team focused on exploring use cases of emerging technologies such as VR, real-time 3D engines, and photogrammetry for Georgia Tech courses, research labs, and student/faculty organizations. \
            We also partnered with NVIDIA and Microsoft to evaluate usage of their new Omniverse and Mesh softwares for higher education.',
            plist: 'Here is a list of some of the projects I led or worked on:',
        } ,
        list1: {
            li1: 'Arts@Tech - Digital Art District for online exhibition of work by student organizations (interactive viewer for Erato Magazine editions, \
            online theater for Buzz Studios short films, 3D motion capture performance by TekStyles dancers), and GT arts initiatives (photogrammetry scans of public art pieces)',
            li2: 'Mechanical Engineering Department - Digitial Twin / Interactive Tour of the Student Competition Center Tour using Matterport photogrammetry scans of the space and vehicles built by motorsport student organizations',
            li3: 'LMCFilms - Film pre-production workflow tutorial for storyboarding using photogrammetry scans',
            li4: 'GT Campus Development - To-scale massing model of the entire Georgia Tech campus ',
            li5: 'LMC 3407 - Camera Settings + Lens Size Learning Lab ',
            li6: 'ME 2110 - Robot and competition arena task simulation',
            li7: 'IMAGINE Lab - Kendeda Building Digital Twin',
            li8: 'Aerospace Systems Design Lab - Moon Habitat Digital Twin',
            li11: 'Architecture Department - Capstone Visualization with real-world location / time-of-day lighting',
            li9: 'NVIDIA Omniverse - Light ray simulation of the Camera Obscura effect',
            li10: 'NVIDIA Omniverse - Accurate physics-based trebuchet ',
        },
        links: {
            //Description, link, type, image
            lk1: ['OIT - NVIDIA Omniverse Projects','https://www.youtube.com/watch?v=RCdzroUtEZc&list=PLtgqXFBFu9f1bErwA9hQqkkWIuaq9S8dz', 'a', '/assets/images/experience/gt-oit-omniverse.jpeg'],
            lk2: ['OIT - Microsoft Mesh Projects','https://www.youtube.com/watch?v=6S0_1a1b8k4&list=PLtgqXFBFu9f0wNr6N7sdX6bJ7HXPm-VOQ', 'a', '/assets/images/experience/gt-oit-nda.png'],
            lk3: ['Co-worker\'s Write Up of the SCC Tour','https://www.jackenglish.net/portfolio/student-competition-center-photogrammetry-tour', 'a', '/assets/images/projects/gtxr-bdbi-vrsa.png' ],
        }
    },

    {
        title: 'Game Development Extern',
        img: '/assets/images/experience/shipwright-studios-1710.avif',
        //link: 'https://expressivemachinery.gatech.edu/projects/luminai/',
        details: {
            origin: 'Shipwright Studios',
            date: 'Winter 2022',
            tools: 'C#, Unity, Substance Painter, Blender, Figma',
            description: 'Generalist Unity game development training'
        },
        slug: 'shipwright-2022',
        desc: {
            p1: 'In Winter 2022, I participated in a two-week program where I developed a solo project under the guidance of the company’s cofounder. The experience covered the full spectrum of game development — from pitching and game design to 3D modeling and gameplay programming.',
        } ,
        list1: {
            li1: 'Created active ragdoll physics system for player and NPC characters ',
            li3: 'Designed 30+ optimized low-poly 3D models in Blender',
            li4: 'Implemented ezy-slice Unity framework for realtime mesh fragmentation',
            li5: 'Developed backend gameplay systems for stats and leaderboard monitoring'
        },
        links: {
            //Description, link, type, image
            lk1: ['Ragduel','https://conatordev.itch.io/ragduel', 'a', '/assets/images/projects/GameDev/ragduel.png'],
            lk1: ['Ragduel Pitch Deck','/assets/images/projects/GameDev/ragduel-pitch-deck.pdf', 'a', '/assets/images/projects/GameDev/ragduel-pitch.png'],
        }
        
    },


    
];
  
export const projectData = [
    {
        title: 'KinoPilot - AR Filmmaking',
        img: '/assets/images/projects/KinoPilot.png',
        link: 'https://devpost.com/software/ar-script-supervisor',
        details: {
            origin: 'ImmerseGT XR Hackathon',
            date: 'Spring 2026',
            tools: 'Snap Spectacles, Lens Studio, JS, Gemini API',
            description: 'Filmmaking multitool for indie film directors built for Spectacles AR glasses, including screenplay viewer, shot notes logger, and AI script supervisor',
            award1: '1st Place - Snap AR Track',
        }
    },
    
    {
        title: 'Buzz Studios Film Archive',
        img: '/assets/images/projects/buzzstudios-archive.png',
        link: 'https://github.com/Buzz-Studios-Development-Team/BuzzStudiosFilmArchive',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025 - Spring 2026',
            tools: 'React, Node.js, GCP, HTML/CSS/JS',
            description: 'Developer for film club\'s in-house short film streaming service hosting projects dating back to 2001 and various admin tools',
        }
    },

    {
        title: 'VR Heartrate State Analysis',
        img: '/assets/images/projects/gtxr-bdbi-vrsa.png',
        //link: 'https://github.com/connorwright1122/anim2spritesheet',
        details: {
            origin: 'VR @ GT / Big Data Big Impact Club',
            date: 'Spring 2025 - Spring 2026',
            tools: 'C#, Unity, Python/PyTorch, ADB, JavaScript',
            description: 'ML-based prediction of heartrate using micro-movements of VR headset motion sensor data for biometrics-driven dynamic 3D scenes',
        },
        slug: 'gtxr-hr',
        desc: {
            p1: 'As part of the VR State Analysis Project, we created a VR heart-rate detection system that uses heartbeat-induced micro-movements in the headset to estimate a player’s BPM. \
            We developed localized data-collection scripts to train our custom machine-learning models, while a lightweight client sends headset motion data to a server for real-time heartbeat inference. \
            The system also integrates with a Polar H10 sensor for ground-truth comparison. \
            Our demo scene reimagines the classic VR plank experience, capturing heart-rate changes at key moments and displaying a chart of BPM over time. \
            This proof-of-concept highlights how real-time biometrics can be used to dynamically shape a player’s in-game world and emotional experience.',
            plist: 'Here is a list of some of the specific things I worked on:',
        } 
    },
    
    {
        title: 'Buzz Studios Location Scout Discord Bot',
        img: '/assets/images/projects/buzzstudios-bot.png',
        link: 'https://github.com/connorwright1122/location-scout-bot',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Summer 2025',
            tools: 'Python, Discord API',
            description: 'Discord bot to archive information for user-submitted film shoot locations',
        }
    },
    
    {
        title: 'Buzz Studios Automated Waiver Generator',
        img: '/assets/images/projects/buzzstudios-waiver.webp',
        link: 'https://github.com/connorwright1122/waiver-generator',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Summer 2025',
            tools: 'React, HTML/CSS/JS, Python, FastAPI',
            description: 'Dynamic liability waiver generator to reduce time spent on-set by executives collecting signatures',
        }
    },

    {
        title: '3D Character to 2D AI Imagery Pipeline',
        img: '/assets/images/projects/hirez-bp.png',
        //link: 'https://github.gatech.edu/pages/riyer75/4641/',
        details: {
            origin: 'Hi-Rez Studios',
            date: 'Summer 2024 - Spring 2025',
            tools: 'Unreal Engine, Python/PyTorch/Pandas, InvokeAI',
            description: 'AI-powered tools and workflows for dataset generation, model training, and AI-generated image segmentation',
        },
        slug: 'hi-rez-2024',
        desc: {
            p1: 'From June 2024 to January 2025, I had the opportunity to work with a team of UI, concept, and FX artists \
            at Hi-Rez Studios to explore use cases of generative AI tools across all stages of game art preceeding the launch of Smite 2. \
            We focused on what was possible using open-source models and InvokeAI, an artist-first tool that enables the use of sketches and other work to guide the image generation process.\
            Proof of concept testing showed that using these resources and other tools that I created, asset creation time could be reduced by up to 75% and turn day-long projects into <3-hour tasks. \ ',
            plist: 'Here is a list of some of the specific things I worked on:',
        } ,
        list1: {
            li1: 'Unreal Engine blueprint for automatically creating image datasets of in-game characters for use in custom model training',
            li2: 'Automatic dataset captioner using Salesforce\'s BLIP model and JSONL file training paramaters generator',
            li3: 'Image segmentation tool capable of separating AI-generated image into a PSD file with artist-friendly layers using the PSDTools library and K-Means clustering for further touchups in Photoshop',
            li4: 'Node-based workflows inside Invoke for streamlining specific use cases (ex. Sketch to Painterly, Graybox to In-Game Screenshot)',
            li5: 'Pipelines / models for remastering Smite 1 ability icons into the Smite 2 art style',
            li6: '20+ Stable Diffusion LoRA image models for 3D characters, particle FX, UI icons, concept art, and personal art styles',
        }
    },

    {
        title: 'ML Inland Water Quality Predictor',
        img: '/assets/images/projects/aquasat.jpg',
        link: 'https://github.gatech.edu/pages/riyer75/4641/',
        details: {
            origin: 'CS 4641 - Machine Learning - Semester-Long Project',
            date: 'Spring 2025',
            tools: 'Python/PyTorch/Pandas',
            description: 'ML-based estimation of inland water quality using satellite imagery reflectance data',
        }
    },

    {
        title: 'VTT Caption AI Translator',
        img: '/assets/images/projects/vtt-ai.jpg',
        link: 'https://github.com/Buzz-Studios-Development-Team/vtt-ai-translator',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Python, OpenAI API',
            description: 'Fluent translation of VTT subtitle files using OpenAI API',
        }
    },

    {
        title: 'Tachyon Deliverance',
        img: '/assets/images/projects/TachyonStill_2.5.2.jpg',
        link: 'https://connorwright1122.github.io/tachyon-deliverance/',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Blender, DaVinci Resolve, Photoshop, Figma, InvokeAI, TRELLIS, Hunyuan 3D',
            description: 'Director/Writer/Editor/VFX Artist/Prop Master for Sci-Fi Comedy short film with 20+ VFX shots with AI-powered workflows for 2D / physical asset generation.',
        }
    },

    {
        title: 'Early Modern English Text Analysis Tools',
        img: '/assets/images/projects/vip_img1_0.png',
        link: 'https://github.gatech.edu/VIP-HistoricalTexts/OrthographyTeam',
        details: {
            origin: 'GT VIP Program',
            date: 'Spring 2024 - Spring 2025',
            tools: 'Python, PyTorch, SLURM',
            description: 'HPC tools for analyzing orthography / spelling variation over time in Early Modern English Texts',
        }
    },

    {
        title: 'Custom Computer Graphics Scenes',
        img: '/assets/images/projects/3451-final.png',
        link: 'https://www.instagram.com/p/DD5bMxnpglH/?hl=en&img_index=1',
        details: {
            origin: 'CS 3451 - Computer Graphics',
            date: 'Fall 2024',
            tools: 'OpenGL, C++, GLSL',
            description: 'Custom implementations of computer graphics algorithms completed during CS 3451',
        }
    },

    {
        title: 'anim2spritesheet',
        img: '/assets/images/projects/anim2spritesheet-cover-2.jpg',
        link: 'https://github.com/connorwright1122/anim2spritesheet',
        details: {
            origin: 'Blender Addon',
            date: 'Summer 2024',
            tools: 'Python, Blender API, PIL',
            description: 'Automatic rendering of 3D animations as 2D albedo, normal, or emission spritesheets',
        }
    },

    {
        title: 'Invoke AI Prompt Builder',
        img: '/assets/images/projects/GTPM-Invoke.jpg',
        link: 'https://docs.google.com/document/d/1MZDG4yYLGb5hRCRPTSaC1IrqAaKX4BRSO0LPUX32Z0Y/edit?tab=t.0',
        details: {
            origin: 'Product @ GT / Invoke AI Collaboration',
            date: 'Spring 2024',
            tools: 'InvokeAI, Figma, Photoshop',
            description: 'Proposed redesign / features for prompt-building experience of OSS Invoke AI image generator',
        }
    },

    {
        title: 'LuminAI Research / Developer Tools',
        img: '/assets/images/projects/luminai-ss.png',
        link: 'https://youtu.be/39KtahFtd3s?si=fVzPbntVArJiVVkB',
        details: {
            origin: 'Expressive Machinery Lab',
            date: 'Spring 2024',
            tools: 'C#, Unity, NoSQL, MongoDB, Blender',
            description: 'Tools for LuminAI developers/researchers - gesture database visualizer, performance manager UI, etc.',
        }, 
        slug: 'eml-2024',
        desc: {
            p1: 'In Spring 2024, I worked for Georgia Tech\'s Expressive Machinery Lab under Dr. Brian Magerko. \
            I was lucky to be a part of the LuminAI team as they prepared for the world\'s first AI-Human improv dance performance, the culmination of 10+ years of prior research where human actions drive live generated responses from an embodied AI agent. \
            My tasks primarily focused on creating Unity and MongoDB-based tools for the researchers to aid in data collection, visualization, and performance management.',
            plist: 'Here is a list of some of the specific things I worked on:',
        } ,
        list1: {
            li1: 'Developed gesture database viewer for 3D visualization of movements and simpler database file management / cleanup ',
            li2: 'Created CSV-based interaction logging system with Azure Kinect SDK for use in KSU dance class for data collection',
            li3: 'Various bug fixes for avatar\'s inverse kinematic bone system and animation playback',
            li4: 'Designed algorithms to apply Viewpoints movement theories to AI avatar\'s gestures',
            li5: 'Wrote scripts to parse live audience responses to questionnaire and playback inside Unity scene',
            li6: 'Implemented UI designs and functionalities for avatar setting management during live performance'
        },
        links: {
            //Description, link, type, image
            lk1: ['Full Performance (Edited)','https://youtu.be/39KtahFtd3s?si=3arvfdaqyrA_gP42', 'yt', ''],
            lk2: ['Full Performance (Unedited)','https://youtu.be/2769H-81EmI', 'yt', ''],
            lk3: ['LuminAI Project Site','https://expressivemachinery.gatech.edu/luminai/', 'a', '/assets/images/projects/luminai-poster.png' ],
        }
    },

    {
        title: 'GT OIT XR Projects',
        img: '/assets/images/projects/oit-campus.jpg',
        //link: 'https://github.com/connorwright1122/anim2spritesheet',
        details: {
            origin: 'GT OIT Academic/Research Technology Division',
            date: 'Spring 2024',
            tools: 'C#, Unity, Blender, LumaAI, NVIDIA Omniverse',
            description: 'Cross-organizational XR projects for virtual tours, simulations, photogrammetry, and digital twins',
        }
    },

    {
        title: 'Dun Dun Dungeon',
        img: '/assets/images/projects/DunDunDungeonLogo.png',
        link: 'https://connorwright1122.github.io/2340Team24Site/',
        details: {
            origin: 'CS 2340 - Objects & Design - Semester-Long Project',
            date: 'Fall 2023',
            tools: 'Java, Android Studio',
            description: 'Android game utilizing MVC architecture and design patterns',
        }
    },

    {
        title: 'VectorViz',
        img: '/assets/images/projects/VectorViz.png',
        link: 'https://devpost.com/software/vdbviz',
        details: {
            origin: 'AI ATL Hackathon 2023',
            date: 'Fall 2023',
            tools: 'Svelte, Python, GCP, OpenAI API, Flask, FAISS, BERT',
            description: 'Interactive nodal visualization / exploration / AI chat of vector databases',
            award1: '1st Place - BCGX Business Innovation Track',
            award2: 'Honorable Mention - Best Use of Google Cloud'
        }
    },

    {
        title: 'PantryPal',
        img: '/assets/images/projects/PantryPalLogo.png',
        link: 'https://devpost.com/software/pantry-pal-4aeqmh',
        details: {
            origin: 'HexLabs HackGT X',
            date: 'Fall 2023',
            tools: 'React.js, HTML/CSS/JS, Tesseract.js, Figma',
            description: 'Sustainable CV-powered kitchen recipe generator React web app',
        }
    },

    {
        title: 'Tron: Disc Wars XR',
        img: '/assets/images/projects/tron-xr.png',
        link: 'https://devpost.com/software/tron-lives',
        details: {
            origin: 'ImmerseGT XR Hackathon 2023',
            date: 'Spring 2023',
            tools: 'C#, Unity, Photon SDK, Meta Interaction SDK',
            description: 'Multiplayer co-location mixed-reality duels inspired by Tron: Legacy',
            award1: '1st Place - Virtual Adventures Track (Best in Sports & Gaming)'
        }
    },

    {
        title: 'uTime',
        img: '/assets/images/projects/uTimeApp.png',
        link: 'https://www.youtube.com/watch?v=3lNHDCUK9fY',
        details: {
            origin: 'GDSC Google Solutions Challenge 2023',
            date: 'Spring 2023',
            tools: 'Dart, Java, Flutter, Firebase, Figma',
            description: 'Cooperative screentime tracking app with friends system to combat technostress',
        }
    },

    {
        title: 'Buzz Cafe',
        img: '/assets/images/projects/buzzcafe-screenshot.png',
        link: 'https://devpost.com/software/buzzcafe',
        details: {
            origin: 'HexLabs Horizons Arts + Tech Hackathon 2023',
            date: 'Spring 2023',
            tools: 'C#, Unity, Meta Interaction SDK',
            description: 'Immersive VR social space and interactive art experience',
        }
    },

    {
        title: 'RUINAE + Unity Course Curriculum',
        img: '/assets/images/projects/GameDev/ruinae.png',
        link: 'https://conatordev.itch.io/ruinae',
        details: {
            origin: 'HS STEM Capstone',
            date: 'Fall 2021 - Spring 2022',
            tools: 'C#, Unity, Blender, Photoshop',
            description: 'Unity-based action-platformer game using custom 3D-to-2D sprite art pipeline',
        }
    },

    {
        title: 'STEM Lab Project Renovations',
        img: '/assets/images/projects/claw-machine.webp',
        link: 'https://www.youtube.com/watch?app=desktop&v=K7-B12MxqJo',
        details: {
            origin: 'HS STEM Computer Technology Class',
            date: 'Fall 2021 - Spring 2022',
            tools: 'C, C++, Arduino, Windows Batch Scripting',
            description: 'Renovations to Claw Machine (conversion to new Arduino motor library) and Arcade Machine (expanding emulator to play Unity and Python games)',
        }
    },

    {
        title: 'STEMobile Electric Vehicle',
        img: '/assets/images/projects/stemobile.webp',
        link: 'https://www.fellowshipchristianschool.org/academics/stem/major-projects/stemobile-build',
        details: {
            origin: 'HS STEM Junior Capstone',
            date: 'Fall 2020 - Spring 2021',
            tools: 'C, C++, Arduino',
            description: 'Digital Systems for Arduino-motor communication, led touchscreen UI design and integration',
        }
    },
];
  
export const gamedevData = [
    {
        title: 'Slalomonella',
        img: '/assets/images/extras/gamedev/salmon.png',
        link: 'https://conatordev.itch.io/slalomonella',
        details: {
            origin: 'Big Mode Game Jam 2026',
            date: 'Spring 2026',
            tools: 'C#, Unity, Blender',
            description: 'Salmon-based platformer',
        }
    },
    
    {
        title: 'Kaijumo!',
        img: '/assets/images/extras/gamedev/kaijumo.jpg',
        link: 'https://conatordev.itch.io/kaijumo',
        details: {
            origin: 'GMTK Game Jam 2024',
            date: 'Summer 2024',
            tools: 'C#, Unity, Blender',
            description: 'Mini-Kaiju arcade brawler inspired by classic Godzilla films',
        }
    },

    {
        title: 'Detective Deckname and the Universal Solvent',
        img: '/assets/images/extras/gamedev/deckname-poster-short.jpg',
        link: 'https://conatordev.itch.io/detective-deckname-and-the-universal-solvent',
        details: {
            origin: 'Pirate Software Game Jam 15',
            date: 'Summer 2024',
            tools: 'C#, Unity, Blender, YarnSpinner',
            description: 'Comedy-Mystery-Narrative-Puzzler in a Cyber-Noir world',
        }
    },

    {
        title: 'DEBUGGER',
        img: '/assets/images/extras/gamedev/DebuggerLogo.png',
        link: 'https://conatordev.itch.io/debugger',
        details: {
            origin: 'LMC 2700 - Computational Media - Final Project',
            date: 'Spring 2024',
            tools: 'C#, Unity, Blender',
            description: 'DOOM-style first person shooter',
        }
    },

    {
        title: 'Occipital Route',
        img: '/assets/images/extras/gamedev/occipitalroute.png',
        link: 'https://conatordev.itch.io/occipital-route',
        details: {
            origin: 'GMTK Game Jam 2023',
            date: 'Summer 2023',
            tools: 'C#, Unity, Blender',
            description: 'Reverse-survival-horror where you play as the monster hunting a speedrunner',
        }
    },

    {
        title: 'Die Recast',
        img: '/assets/images/extras/gamedev/dierecast.png',
        link: 'https://conatordev.itch.io/die-recast',
        details: {
            origin: 'GMTK Game Jam 2022',
            date: 'Summer 2022',
            tools: 'C#, Unity, Blender',
            description: 'Isometric physics-based roguelite boss battle',
        }
    },

    {
        title: 'To USB',
        img: '/assets/images/extras/gamedev/tousb.png',
        link: 'https://conatordev.itch.io/to-usb',
        details: {
            origin: 'Lost Relic Game Jam 2022',
            date: 'Summer 2022',
            tools: 'C#, Unity, Blender',
            description: 'Rage-bait 3D platformer',
        }
    },

    {
        title: 'Ruinae',
        img: '/assets/images/projects/GameDev/ruinae.png',
        link: 'https://conatordev.itch.io/ruinae',
        details: {
            origin: 'HS STEM Capstone',
            date: 'Fall 2021 - Spring 2022',
            tools: 'C#, Unity, Blender',
            description: '2D Action Platformer with a custom 3D-to-2D sprite art pipeline',
        }
    },

    {
        title: 'Ragduel',
        img: '/assets/images/projects/GameDev/ragduel.png',
        link: 'https://conatordev.itch.io/ragduel',
        details: {
            origin: 'GMTK Game Jam 2023',
            date: 'Spring 2022',
            tools: 'C#, Unity, Blender',
            description: 'First person ragdoll physics-based arena combat',
        }
    },
];

export const classData = [
  {
    "number": "AECT 2030",
    "name": "Leaders in Progress & Service for the Creative Industries",
    "skills": "Design thinking, creative entrepreneurship, storytelling principles"
  },
  {
    "number": "CS 1331",
    "name": "Intro to Object Oriented Programming",
    "skills": "Java, OOP, debugging, software design basics"
  },
  {
    "number": "CS 1332",
    "name": "Data Structures & Algorithms",
    "skills": "Java, data structures, algorithms, complexity analysis"
  },
  {
    "number": "CS 2050",
    "name": "Intro to Discrete Math",
    "skills": "logic, proofs, sets, functions, combinatorics, graph theory"
  },
  {
    "number": "CS 2110",
    "name": "Computer Organization & Programming",
    "skills": "C, assembly, memory management, low-level programming"
  },
  {
    "number": "CS 2340",
    "name": "Objects & Design",
    "skills": "Java, MVC, design patterns, Git, team projects, Agile practices"
  },
  {
    "number": "CS 3001",
    "name": "Computing & Society",
    "skills": "ethics in computing, technology policy, societal impacts of computing"
  },
  {
    "number": "CS 3451",
    "name": "Computer Graphics",
    "skills": "OpenGL, C++, linear algebra, rendering pipelines, transformations, ray tracing"
  },
  {
    "number": "CS 3510",
    "name": "Design & Analysis of Algorithms",
    "skills": "algorithm design, proofs of correctness, NP-completeness"
  },
  {
    "number": "CS 3600",
    "name": "Intro to Artificial Intelligence",
    "skills": "Python, search algorithms, heuristics, probability, machine learning basics"
  },
  {
    "number": "CS 3630",
    "name": "Intro to Robotics & Perception",
    "skills": "Python, ROS, computer vision, robotics, SLAM, perception"
  },
  {
    "number": "CS 4476",
    "name": "Computer Vision",
    "skills": "Python, Pytorch, image convolution, SIFT feature matching, neural networks, deep learning, semantic segmentation, neural radiance fields"
  },
  {
    "number": "CS 4488",
    "name": "Procedural Content Generation",
    "skills": "C#, generative algorithms, randomness, game design tools, Unity, Unreal"
  },
  {
    "number": "CS 4641",
    "name": "Machine Learning",
    "skills": "Python, scikit-learn, regression, classification, clustering, neural networks"
  },
  {
    "number": "CS 4650",
    "name": "Computer Audio",
    "skills": "JavaScript, signal processing, digital audio synthesis, audio programming"
  },
  {
    "number": "CS 4731",
    "name": "Game AI",
    "skills": "Unity, C#, pathfinding, decision trees, behavior trees, state machines, reinforcement learning"
  },
  {
    "number": "ISYE 3770",
    "name": "Statistics & Applications",
    "skills": "R, Python, hypothesis testing, regression, probability, data analysis"
  },
  {
    "number": "LMC 2700",
    "name": "Intro to Computational Media",
    "skills": "HTML/CSS/JavaScript, Three.js, creative coding, Python, media studies, HCI"
  },
  {
    "number": "LMC 2720",
    "name": "Principles of Visual Design",
    "skills": "Adobe Creative Suite, Figma, visual design, typography, layout"
  },
  {
    "number": "LMC 3252",
    "name": "Studies in Film & Television",
    "skills": "film theory, media analysis, narrative design"
  },
  {
    "number": "LMC 3403",
    "name": "Tech Communication",
    "skills": "Figma, technical communication, design accessibility, project management"
  },
  {
    "number": "MATH 1554",
    "name": "Linear Algebra",
    "skills": "matrices, vector spaces, eigenvalues"
  },
  {
    "number": "MATH 2550",
    "name": "Multivariable Calculus",
    "skills": "partial derivatives, multivariable optimization, vector calculus"
  },
  {
    "number": "MATH 3012",
    "name": "Applied Combinatorics",
    "skills": "combinatorics, probability, graph theory, discrete optimization"
  },
  {
    "number": "PHYS 2211",
    "name": "Intro Physics I",
    "skills": "classical mechanics, problem solving, modeling physical systems"
  }
]
